/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Topic of the assessment

Values: 0=E1, 1=E2, 2=E3, 3=E4, 4=E5, 5=S1, 6=S2, 7=S3, 8=S4, 9=G1, 10=OTHER
 * @export
 * @enum {number}
 */

export enum DoubleMaterialityESRSAreaEnum {
    E1 = 0,
    E2 = 1,
    E3 = 2,
    E4 = 3,
    E5 = 4,
    S1 = 5,
    S2 = 6,
    S3 = 7,
    S4 = 8,
    G1 = 9,
    OTHER = 10
}


